export const env = {
  api_url: process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8100/api',
  re_captcha_key: process.env.NEXT_PUBLIC_RE_CAPTCHA_KEY || '',
  site_url:
    (process.env.NEXT_PUBLIC_SITE_URL ?? process.env.NODE_ENV === 'development')
      ? 'https://storefront-dev.lentho.com'
      : 'https://lentho.com',
  activeHostedEmbedURL: process.env.NEXT_PUBLIC_ACTIVE_HOSTED_EMBED_URL,
};

export const storage_keys = {
  locale: '4TA_LOCALE',
  customer_token: '4TA_CUSTOMER_TOKEN',
  customer_refresh_token: '4TA_CUSTOMER_REFRESH_TOKEN',
  customer_profile: '4TA_CUSTOMER_PROFILE',
  customer_cart: '4TA_CART',
  restaurant_token: '4TA_RESTAURANT_TOKEN',
  restaurant_refresh_token: '4TA_RESTAURANT_REFRESH_TOKEN',
  restaurant_profile: '4TA_RESTAURANT_PROFILE',
  admin_profile: '4TA_ADMIN_PROFILE',
  admin_token: '4TA_ADMIN_TOKEN',
  impersonate_id: '4TA_IMP_ID',
  res_impersonate_id: '4TA_RES_IMP_ID',
  restaurant_lang: 'res_ln',
  res_profile_bnfc: 'res_profile_banner_nfc',
  restaurant_dashboard_bnfc: 'restaurant_dashboard_bnfc',
  res_employee_dashboard_bnfc: 'res_employee_dashboard_bnfc',
  res_driver_dashboard_bnfc: 'res_driver_dashboard_bnfc',
  storefront_homepage_bnfc: 'storefront_homepage_bnfc',
  banner_notifications: 'banner_notifications',
  last_restaurant_notification: 'last_restaurant_notification',
  last_customer_notification: 'last_customer_notification',
  res_token: 'srv_res_token',
  firebase_device_token: 'firebase_device_token',
  last_failed_order: 'last_failed_order',
  show_failed_order_popup: 'show_failed_order_popup',
  customer_referral_code: 'LENTHO_CUSTOMER_REFERRAL_CODE',
  referral_search_param: 'referral',
  registration_completion_token: 'registration_completion_token',
  customer_registration_otp: 'customer_registration_otp',
  business_registration_otp: 'business_registration_otp',
};

export const defaultFormLocale = 'en';

export const formLocales = ['de', 'en'];

export const restaurantBasePath = `/business/dash`;

export const notificationType: any = {
  'App\\Notifications\\RestaurantNewOrder': 'New order placed',
  'App\\Notifications\\RestaurantReviewPosted': 'New review posted.',
  'App\\Notifications\\RestaurantOrderCancelRequest':
    'Requested for order cancel',
  'App\\Notifications\\RestaurantOrderUpdate': 'Updated order',
};

export const APP_BRAND_NAME = 'LENTHO';
export const BRAND_LOGO_ALT_TEXT = `${APP_BRAND_NAME} logo`;

export const parentTagSwiperID = 'parent_tag';
export const childTagSwiperID = 'child_tag';

export const SHOP_TYPES = {
  online_shop: 'online_shop',
  restaurant: 'restaurant',
};

export const initialTagsToShow =
  process.env.NODE_ENV === 'development' ? 9 : 15;

export const DEFAULT_POPUP_OPEN_DELAY = 2000;
export const DEFAULT_POPUP_REOPEN_DELAY = 30000;
export const PROMO_POPUP_DELAY_DISABLED = 'einfach-sparsam';
export const DEFAULT_POPUP_SHOW_COUNT = 1;
export const midnight = '00:00';

type CategoryType = {
  id: number;
  order_index: number;
  title: {
    de: string;
    en: string;
  };
  link?: string;
};

export const categories: CategoryType[] = [
  {
    id: 228,
    order_index: 0,
    title: {
      de: 'TOP DEALS',
      en: 'TOP DEALS',
    },
  },
  {
    id: 203,
    order_index: 0,
    title: {
      de: 'Kostenlos',
      en: 'For free',
      // de: 'Marktplatz',
      // en: 'Marketplace',
    },
    link: 'https://blog.lentho.com/gratis-deals/',
  },
  {
    id: 140,
    order_index: 1,
    title: {
      de: 'Fashion',
      en: 'Fashion',
    },
  },
  {
    id: 59,
    order_index: 2,
    title: {
      de: 'Food',
      en: 'Food stores',
    },
  },
  {
    id: 138,
    order_index: 2,
    title: {
      de: 'Beauty',
      en: 'Beauty',
    },
  },
  {
    id: 172,
    order_index: 2,
    title: {
      de: 'Reisen',
      en: 'Travel',
    },
  },
  {
    id: 165,
    order_index: 2,
    title: {
      de: 'Haus & Garten',
      en: 'Haus & Garten',
    },
  },
  {
    id: 187,
    order_index: 2,
    title: {
      de: 'Gesundheit',
      en: 'Health',
    },
  },
  {
    id: 194,
    order_index: 2,
    title: {
      de: '(Haus-)Tiere',
      en: 'Pets',
    },
  },
  {
    id: 176,
    order_index: 2,
    title: {
      de: 'Technik',
      en: 'Technology',
    },
  },
  {
    id: 136,
    order_index: 2,
    title: {
      de: 'Sport',
      en: 'Sport',
    },
  },
  {
    id: 214,
    order_index: 2,
    title: {
      de: 'Schmuck',
      en: 'Jewelry',
    },
  },
  // {
  //   id: 139,
  //   order_index: 2,
  //   title: {
  //     de: 'Kids',
  //     en: 'Kids',
  //   },
  // },
  // {
  //   id: 181,
  //   order_index: 2,
  //   title: {
  //     de: 'Bücher & Co',
  //     en: 'Bücher & Co',
  //   },
  // },
  // {
  //   id: 186,
  //   order_index: 2,
  //   title: {
  //     de: 'Geschenkideen',
  //     en: 'Geschenkideen',
  //   },
  // },
  // {
  //   id: 209,
  //   order_index: 2,
  //   title: {
  //     de: 'Freizeit',
  //     en: 'Freizeit',
  //   },
  // },
  // {
  //   id: 209,
  //   order_index: 2,
  //   title: {
  //     de: 'Alle Deals',
  //     en: 'Alle Deals',
  //   },
  // },
];

export const countryCodesForMobile = {
  de: '+49',
};
